import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { getJSON } from '../../../../../common/services/api'
import type {
  FilterValues,
  GoalReportListType,
  QueryFilterValues
} from '../types'

export const generateApiUrl = (
  filterParams: QueryFilterValues,
  utcOffset: number
) => {
  const { residents, goalStatuses, reviewStatuses } = filterParams

  const queryStr = getQueryParams({
    serviceUsers: residents,
    status: goalStatuses,
    reviewStatus: reviewStatuses,
    utcOffset
  })

  return `/list/goals/report-list?${queryStr}`
}

export const useGoalsReportList = (filterValues: FilterValues) => {
  const utcOffset = -new Date().getTimezoneOffset()

  const GET_GOALS_REPORT_LIST = generateApiUrl({ ...filterValues }, utcOffset)
  const { data, isLoading, error } = useQuery(
    [
      'goal-report-list',
      filterValues.residents,
      filterValues.goalStatuses,
      filterValues.reviewStatuses
    ],
    () =>
      getJSON({
        url: `${GET_GOALS_REPORT_LIST}`
      }),
    { enabled: true }
  )
  const goalData = data?.data as GoalReportListType[]
  return { data: goalData, isLoading, error }
}
